/**
 * Centralized dayjs instance with required plugins.
 * Import this instead of 'dayjs' directly to ensure plugins are always loaded.
 *
 * Replaces moment.js (~300KB) with dayjs (~2KB) for date operations.
 */
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import 'dayjs/locale/es';

dayjs.extend(isoWeek);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
dayjs.extend(quarterOfYear);
dayjs.locale('es');

export default dayjs;
